import { createRouter, createWebHashHistory } from 'vue-router';
import i18n from '@/i18n';

export default function initialize() {
  const router = createRouter({
    history: createWebHashHistory(),
    routes: [],
  });

  router.beforeEach((to, _from, next) => {
    const page = to.name ? i18n.global.t(`pageTitles.${to.name}`) : '';
    document.title = i18n.global.t('idm.pageTitle', { page });
    next();
  });

  return router;
}
